import { render, staticRenderFns } from "./FormDinamico.vue?vue&type=template&id=7bd22e7d&scoped=true"
import script from "./FormDinamico.vue?vue&type=script&lang=js"
export * from "./FormDinamico.vue?vue&type=script&lang=js"
import style0 from "./FormDinamico.vue?vue&type=style&index=0&id=7bd22e7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd22e7d",
  null
  
)

export default component.exports